/** Encoded current portal URL for SSO redirect tracking (decode with decodeURIComponent). */
export const getEncodedRefUrl = (): string =>
  encodeURIComponent(window.location.href);

export const appendRefUrlParam = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}ref_url=${getEncodedRefUrl()}`;
};
